import React, { useContext } from 'react';
import acceptedCards from '../../../images/accepted_cards.svg';
import { ConfigContext } from '../../../context/Config';
import { loadStripe } from '@stripe/stripe-js/pure';
import '../Checkout.less';

loadStripe.setLoadParameters({ advancedFraudSignals: false });

export type StripeProps = {
  onSelect?: (type: string) => void;
};

const TArca: React.FC<StripeProps> = ({ onSelect }) => {
  const { translate } = useContext(ConfigContext);
  return (
    <div className="t-payment t-payment-stripe">
      <img
        src={acceptedCards}
        alt="accepted_cards"
        onClick={() => onSelect('stripe')}
      />
    </div>
  );
};

const redirectToPayment = async (
  {
    publishableKey,
    sessionId,
  }: {
    [key: string]: any;
  },
  onError,
) => {
  const stripe = await loadStripe(publishableKey);
  const { error } = await stripe.redirectToCheckout({ sessionId });

  if (error) {
    onError(
      `Strapi redirectToCheckout failed ERROR: ${error && error.message}`,
    );
  }
};

export default TArca;
export { redirectToPayment };
